import { DefaultErrors } from '../../model/error';
import checkJwtToken from './check-jwt-expiration';

export default async function getAccessToken(
  refreshToken: string | undefined,
  platformUrl: string,
  appId: string,
  wafToken: string | undefined = undefined,
): Promise<string> {
  if (!refreshToken || !checkJwtToken(refreshToken)) {
    return Promise.reject(DefaultErrors.INVALID_USER_SESSION);
  }

  const headers: Record<string, string> = {
    'App-Id': appId,
    Authorization: `Bearer ${refreshToken ?? ''}`,
  };
  if (wafToken) {
    headers['x-aws-waf-token'] = wafToken;
  }
  return fetch(`${platformUrl}/v1/access_token`, {
    method: 'POST',
    headers,
    cache: 'no-store',
  })
    .then((response) => {
      if (response.status === 401) {
        throw DefaultErrors.INVALID_USER_SESSION;
      } else if (response.status === 405 && wafToken) {
        throw DefaultErrors.AWS_WAF_CAPTCHA_REQUIRED;
      } else if (response.status === 403 && response.headers['Content-Type'] === 'text/html') {
        throw DefaultErrors.AWS_WAF_REQUEST_BLOCKED;
      }
      return response.json();
    })
    .then((json: Record<string, any>) => {
      if (json.error === 2049) {
        throw DefaultErrors.INVALID_USER_SESSION;
      }
      const payload = json.payload as { access_token: { token: string } };
      return payload.access_token.token;
    });
}
